import "./style.scss";
import { useTranslation } from "react-i18next";

const BetaWarning = () => {
  const {t,i18n}= useTranslation();
  console.log(t('You-can-communicate-your-comments'));
  const subject = encodeURIComponent(t('subject'));
  const email = i18n.language === 'en' ? 'support@amebaresearch.com' : 'soporte@amebaresearch.com';
  return (
    <div className="beta-warning">
      <p>
        <span className="apple">{t('Warning')}</span> : {t('Ameba-Sales-Monitor-contains-new-features-that-are-marked-with')}
        <span
          className="is-new-no-anim"
          title={t('This-section-includes-new-features')}
        >
          &#9733;
        </span>
        <br />
        {t('You-can-communicate-your-comments')}
        <span className="e-mail">
        <a href={`mailto:${email}?subject=${subject}`}>
            {t('Correo')} 
          </a>
        </span>
        &nbsp;{t('Thanks!')}
      </p>
    </div>
  );
};

export default BetaWarning;
